export default __webpack_public_path__ + "static/media/Barrel-512.bba8c9b8.png";